module.exports = __webpack_public_path__ + "img/frsfz2.deb4a19f.png";